import {
  type ErrorsData,
  type TentacleErrorData,
  type ValidationErrorData,
  parseErrorData,
} from 'modules/core/lib/parseErrorData'

export class BusinessError extends Error {
  constructor(data: string) {
    super(data)
    this.name = 'BusinessError'
  }
}

export class NetworkError extends Error {
  constructor(data: string) {
    super(data)
    this.name = 'NetworkError'
  }
}

export class RequestCancelledError extends Error {
  constructor() {
    super()
    this.name = 'RequestCancelledError'
  }
}

export class ValidationError extends Error {
  data: ValidationErrorData
  payload: ErrorsData

  constructor(data: ValidationErrorData) {
    super('Validation error')
    this.data = data
    this.payload = data.errors
    this.name = 'ValidationError'

    if (data.errors) {
      this.message = parseErrorData(data.errors)
    }
  }
}

export class TentacleError extends Error {
  data: TentacleErrorData
  message: string

  constructor(data: TentacleErrorData) {
    super('TentacleError')
    this.data = data
    this.message = data.message
    this.name = 'TentacleError'
  }
}
